import React from "react"
import { Box,  SimpleGrid, Heading, GridItem } from "@chakra-ui/react"
import SkillItem from "../../components/Skill/SkillItem"
import skillsJson from "../../data/skills.json"
import Background from "../../components/Layout/Background"
import a from "../../images/background/25.svg"
import b from "../../images/background/388.svg"
import c from "../../images/background/81.svg"


export default function Skills() {
    const { skills } = JSON.parse(JSON.stringify(skillsJson))

    return (
        <section>
            <Box position="relative" pt="20vh" pb="10vh">
                <Background src={a} left="-22vw" top="15vw" width='15vw' />
                <Background src={b} right="-22vw" bottom="1vw" width='15vw' />
                <Background src={c} right="-10vw" top="8vw" width='4vw' />
                <Heading as="h1" size="2xl" mb={12}>🛠 Skills</Heading>
                <SimpleGrid
                    rows={[4, 4, 1]}
                    columns={[1, 1, 4]}
                    gap={10}
                >
                    {skills.map((skill, i) => {
                        return (    
                            <GridItem key={i} colSpan={1}>
                                <SkillItem category={skill.type} skills={skill.list} />
                            </GridItem>)
                    })
                    }
                </SimpleGrid>
            </Box>
        </section>
    )
}